<div class="frame">
    <app-entity-types></app-entity-types>
    <app-relation-types></app-relation-types>
</div>
